export default __webpack_public_path__ + "c5722996d28d2e9d2199bd27cde66afd.png";